"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardViewProvider = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var contexts_1 = require("./contexts");
var internal_1 = require("../internal");
/**
 * @internal
 */
exports.DashboardViewProvider = function (_a) {
    var children = _a.children, locale = _a.locale, config = _a.config, settings = _a.settings, colorPalette = _a.colorPalette, drillDownAttributes = _a.drillDownAttributes, alerts = _a.alerts, isReadOnly = _a.isReadOnly, execConfig = _a.execConfig;
    return (react_1.default.createElement(internal_1.InternalIntlWrapper, { locale: locale, workspace: settings.workspace },
        react_1.default.createElement(contexts_1.DashboardViewConfigProvider, { config: config },
            react_1.default.createElement(contexts_1.DashboardViewExecConfigProvider, { execConfig: execConfig },
                react_1.default.createElement(contexts_1.UserWorkspaceSettingsProvider, { settings: settings },
                    react_1.default.createElement(contexts_1.ColorPaletteProvider, { palette: colorPalette },
                        react_1.default.createElement(contexts_1.AttributesWithDrillDownProvider, { attributes: drillDownAttributes },
                            react_1.default.createElement(contexts_1.DashboardAlertsProvider, { alerts: alerts },
                                react_1.default.createElement(contexts_1.DashboardViewIsReadOnlyProvider, { isReadOnly: isReadOnly }, children)))))))));
};
//# sourceMappingURL=DashboardViewProvider.js.map